import * as React from "react";
import { WithToast, Loader, withToast, TextInput, SEARCH_SVG, CLOSE_BLUE_SVG } from 'bpm-web-generic';
import { RouteComponentProps, withRouter } from "react-router";
import * as _ from 'lodash'
import { metaAPI } from "src/api/config";
import { Genre } from "src/api/download-api-sdk/src";

class Genres extends React.Component<WithToast & RouteComponentProps, { genres?: Genre[], search: string, filteredGenres?: Genre[] }> {
    constructor(props: WithToast & RouteComponentProps) {
        super(props)
        this.state = {
            search: ''
        }
        this.search = _.debounce(this.search, 300)
    }

    componentDidMount() {
        metaAPI.getGenres('music').then(({ data: genres }) => {
            this.setState({
                genres: genres.filter(g => g.color != undefined).sort((g1, g2) => {
                    return g1.name.localeCompare(g2.name)
                }),
            }, () => {
                this.search()
            })
        }).catch(err => {
            this.props.showToast('danger', 'Sorry, something went wrong. Please try again.')
        })
    }

    private search() {
        let term = this.state.search
        if (term != '') {
            this.setState({
                filteredGenres: (this.state.genres || []).filter((genre) => {
                    return genre.name.toLowerCase().includes(term.toLowerCase())
                })
            })
        } else {
            this.setState({ search: '', filteredGenres: this.state.genres })
        }
    }

    public render() {
        if (!this.state.filteredGenres) {
            return <Loader />
        } else {
            return <>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                    <h3 style={{ lineHeight: '40px', marginRight: '10px' }}>Genres</h3>
                    <TextInput placeholder={/*'Search…'*/''} icon={SEARCH_SVG} rightIcon={this.state.search != '' ? CLOSE_BLUE_SVG : undefined} onRightIconClick={(_e) => {
                        this.setState({ search: '' }, () => {
                            this.search()
                        })
                    }} value={this.state.search} onChange={(e) => {
                        this.setState({ search: e.target.value }, () => {
                            this.search()
                        })
                    }} />
                </div>
                <div className='genre-grid'>
                    {this.state.filteredGenres.map(item => {
                        return <div className={"coverlist-item " + item.slug} key={item.slug} onClick={(e) => {
                            e.preventDefault()
                            this.props.history.push('/new-releases/audio/genre/' + (item.slug as string))
                        }}>
                            <div className="text-container">
                                <div className='item-text item-title text'>{item.name}</div>
                            </div>
                        </div>
                    })}
                </div>
            </>
        }
    }
}
export const GenreView = withRouter(withToast(Genres))


// WEBPACK FOOTER //
// ./src/pages/Genres.tsx